import React from 'react';

export default function Herobody({ children, cstyle }) {
  return (
    <div className='hero-body' style={cstyle ? cstyle : {height: 'calc(100% - 52px)'}}>
      {children}
    </div>
  );
}
